"use client";

import { useCallback } from "react";
import { useRenderAudioSync } from "@/features/lomdaEditorV2/hooks/useRenderAudioSync";
import type { LomdaScene } from "@/features/lomdaEditorV2/lib/lomdaTypes";
import { useActiveRenderRunId, useDocumentActions, useIdentity, useUiActions } from "./hooks";

/**
 * Bridges the in-flight render's audio progress into the store. Renders nothing.
 * Mounted once inside the provider (edit mode only).
 */
export function RenderAudioSync() {
    const { lomdaId } = useIdentity();
    const activeRenderRunId = useActiveRenderRunId();
    const { updateScene } = useDocumentActions();
    const { setActiveRenderRunId } = useUiActions();

    const onAudioRefreshed = useCallback(
        (refreshed: { id: string; audio: NonNullable<LomdaScene["audio"]> }[]) => {
            for (const s of refreshed) updateScene(s.id, { audio: s.audio });
        },
        [updateScene]
    );
    const onRenderTerminated = useCallback(
        () => setActiveRenderRunId(null),
        [setActiveRenderRunId]
    );

    useRenderAudioSync({
        lomdaId,
        activeRenderRunId,
        onAudioRefreshed,
        onRenderTerminated,
    });

    return null;
}
